import { useSelector } from 'react-redux';
import { profileSelector } from '../../store/authentication/authenticationReducerSelectors';

export const useCurrentUser = () => {
  return useSelector(profileSelector);
};
